function isPublicIntentionElementVisible({
  isPrivate,
  isPublicIntention,
}: {
  isPrivate: boolean;
  isPublicIntention: boolean;
}) {
  return !isPrivate || isPublicIntention;
}

export { isPublicIntentionElementVisible };
